import {FilterAnimeGetParams} from "../../../../../../nodeserver/structs/getparams";
import {genres, seasons, statuses, types, typesLong, yearRatings} from "../../../config.js";
import {tjs} from "../../../lang.js";
import {getQueryMap, handleFetchError, YummyServerError} from "../../../helpers/functions.js";
import JSX, {JSXElement} from "../../../helpers/react.js";
import FilterCell from "../FilterCell.js"
import {filterExpand} from "../FilterExpand.js";
import SortOrderButton from "./SortOrderButton.js";
import RefObject = JSX.RefObject;
import {ServerApi} from "../../../api.js";
import {FilterPage} from "./FilterPage.js";
import AbstractFiltersForm from "../AbstractFiltersForm.js";
import {LoadingSpinner, ISelectValue, Select, NumberInput} from "../../elements/index.js";

interface Data {
    selected_category?: number[];
    selected_type?: number[];
    excluded_category?: number[];
    selected_age?: number[];
    status?: number[];
    from_year?: number;
    to_year?: number;
    from_num_episodes?: number;
    to_num_episodes?: number;
    season?: number[];
    sort_order?: 1 | 0
    sort?: string;
}

const sortingOptions: { title: () => string, id: FilterAnimeGetParams['sort'], order: 'ASC' | 'DESC' }[] = [
    {title: () => tjs('sort_relevance'), order: 'DESC', id: 'top'},
    {title: () => tjs('sort_title_az'), order: 'ASC', id: 'title'},
    {title: () => tjs('sort_year'), order: 'DESC', id: 'year'},
    {title: () => tjs('sort_rating'), order: 'DESC', id: 'rating'},
    {title: () => tjs('sort_votes'), order: 'DESC', id: 'rating_counters'},
    {title: () => tjs('sort_views'), order: 'DESC', id: 'views'}
];
type Params = Omit<Omit<FilterAnimeGetParams, 'offset'>, 'limit'>;
export default class FilterAnimeFields extends AbstractFiltersForm<{}, Params, Data> {
    static initialized = false;
    private sortOrderButton: RefObject<HTMLDivElement> = {};
    private randomItemElement: RefObject<HTMLDivElement> = {};

    constructor(props: any, content: any) {
        super(props, content);
        if ((location.pathname.startsWith("/catalog/filter")) && !([FilterAnimeFields.initialized, FilterAnimeFields.initialized = true][0]))
            setTimeout(() => this.filter());
    }

    render() {
        const filterActive = localStorage.filterSwitch == 'true';
        const params = this.params;
        if(!Array.isArray(params.selected_category)) params.selected_category = [params.selected_category! as any];
        if(!Array.isArray(params.selected_type)) params.selected_type = [params.selected_type! as any];
        if(!Array.isArray(params.excluded_category)) params.excluded_category = [params.excluded_category! as any];
        if(!Array.isArray(params.selected_age)) params.selected_age = [params.selected_age! as any];
        if(!Array.isArray(params.status)) params.status = [params.status! as any];
        if(!Array.isArray(params.season)) params.season = [params.season! as any];

        return (
            <div>
                <div className="filter-body">
                    <FilterCell label={tjs('filter_genres')}>
                        <Select name="selected_category[]" placeholder={tjs('filter_genres_ph')} multiple={true}
                                onChange={this.onSelectChange('genres')}>
                            {
                                ...genres.map(
                                    ({value, title, href}) => ({
                                        value: value,
                                        name: title,
                                        selected: params.selected_category?.includes(+value) ?? (this.urlPath === `/catalog/category/${href}`)
                                    } as ISelectValue)
                                )
                            }
                        </Select>
                    </FilterCell>
                    <FilterCell label={tjs('filter_exclude_genres')}>
                        <Select name="excluded_category[]" placeholder={tjs('filter_exclude_genres_ph')} multiple={true}
                                onChange={this.onSelectChange('exclude_genres')}>
                            {
                                ...genres.map(
                                    ({value, title, href}) => ({
                                        value: value,
                                        name: title,
                                        selected: params.excluded_category?.includes(+value) ?? false
                                    } as ISelectValue)
                                )
                            }
                        </Select>
                    </FilterCell>
                    <FilterCell label={tjs('filter_type')}>
                        <Select name="selected_type[]" placeholder={tjs('filter_type_ph')} multiple={true}
                                onChange={this.onSelectChange('types')}>
                            {
                                ...typesLong
                                    .map((type, typeId) => typeId && (
                                        {
                                            selected: params.selected_type?.includes(typeId) ?? false,
                                            name: type,
                                            value: typeId
                                        } as ISelectValue
                                    ))
                            }

                        </Select>
                    </FilterCell>
                    <FilterCell label={tjs('filter_status')}>
                        <Select name="status[]" placeholder={tjs('filter_status')} multiple={true}
                                onChange={this.onSelectChange('status')}>
                            {
                                ...statuses
                                    .map((status, id) => (
                                        {
                                            selected: params.status?.includes(id) ?? (
                                                (location.pathname.startsWith('/catalog/ongoing') && id == 1) ||
                                                (location.pathname.startsWith('/catalog/announcement') && id == 2)
                                            ),
                                            name: status.title,
                                            value: id
                                        } as ISelectValue
                                    ))
                            }

                        </Select>
                    </FilterCell>
                    <FilterCell label={tjs('filter_year')}>
                        <div className='filter-year'>
                            <NumberInput placeholder={tjs('filter_year_from')} name="from_year" value={params.from_year} min={1900}
                                         max={new Date().getUTCFullYear() + 10}
                                         onChange={this.onVariableChange('from_year')}/>
                            <NumberInput placeholder={tjs('filter_year_to')} name="to_year" value={params.to_year} min={1900}
                                         max={new Date().getUTCFullYear() + 10}
                                         onChange={this.onVariableChange('to_year')}/>
                        </div>
                    </FilterCell>
                    <FilterCell label={tjs('filter_season')} collapse={true}>
                        <Select name="season[]" multiple={true} placeholder={tjs('filter_season')}
                                onChange={this.onSelectChange('season')}>
                            {
                                ...seasons
                                    .map((season, id) => id && (
                                        {
                                            selected: (Array.isArray(params.season)?params.season:[])?.includes(id) ?? false,
                                            name: season,
                                            value: id
                                        } as ISelectValue
                                    ))
                            }
                        </Select>

                    </FilterCell>
                    <FilterCell label={
                        <>
                            {tjs('filter_episodes')} <i data-balloon={tjs('filter_ep_tooltip')}
                                                data-balloon-pos="up">
                            <i className="fa fa-sm fa-question-circle"/>
                        </i>
                        </>
                    } collapse={true}>
                        <div className="filter-year">
                            <NumberInput placeholder={tjs('filter_year_from')} name="from_num_episodes" value={params.from_num_episodes}
                                         onChange={this.onVariableChange('ep_from')} min={0} max={999999}/>
                            <NumberInput placeholder={tjs('filter_year_to')} name="to_num_episodes" value={params.to_num_episodes}
                                         onChange={this.onVariableChange('ep_to')} min={0} max={999999}/>
                        </div>
                    </FilterCell>
                    <FilterCell label={tjs('filter_age')} collapse={true}>
                        <Select name="selected_age[]" multiple={true} placeholder={tjs('filter_age')}
                                direction="up" onChange={this.onSelectChange('min_age')}>
                            {
                                ...yearRatings
                                    .map((yearRating, id) => id && (
                                        {
                                            selected: ((Array.isArray(params.selected_age)?params.selected_age:[params.selected_age]) as number[])?.includes(id) ?? false,
                                            name: yearRating.name,
                                            value: id
                                        } as ISelectValue
                                    ))
                            }
                        </Select>
                    </FilterCell>
                    <FilterCell label={tjs('filter_sort')} collapse={false}>
                        <Select name="sort" multiple={false} placeholder={tjs('filter_sort')}
                                style={{zIndex: 1}}
                                onChange={v => {
                                    this.filters.sort = (v?.value ?? 'top')! as any
                                    const sortOrder = (v?.dataSortOrder ?? 'ASC');
                                    this.sortOrderButton.value?.children?.[0]?.setAttribute('data-balloon', sortOrder === 'DESC' ? tjs('filter_desc') : tjs('filter_asc'));
                                    const input = this.sortOrderButton.value?.querySelector<HTMLInputElement>("input[name='sort_order']");
                                    if (input) input.value = sortOrder === 'DESC' ? "0" : "1";
                                    this.filters.sort_forward = sortOrder === 'DESC' ? "false" : "true";
                                }}
                                direction="up">
                            {
                                ...sortingOptions.map((sortOption) => (
                                    {
                                        selected: params.sort?.includes(sortOption.id!) ?? (sortOption.id === 'top'),
                                        name: sortOption.title(),
                                        value: sortOption.id,
                                        dataSortOrder: sortOption.order
                                    } as ISelectValue
                                ))
                            }
                        </Select>
                        <SortOrderButton onChange={v => this.filters.sort_forward = v === 'ASC' ? 'true' : 'false'}
                                         ref={this.sortOrderButton}
                                         sortOrder={'sort_order' in this.params ? (this.params.sort_order == 1 ? 'ASC' : 'DESC') : 'ASC'}/>
                    </FilterCell>

                </div>
                <div className="filter-footer bordered-bottom">
                    <div className="transparent-button bordered-left-only filter-button small show-hide"
                         data-balloon={tjs('filter_expand')} data-balloon-pos="up-left"
                         onClick={filterSwitchToggle}>
                        <i className={["icon-filter-expand", "fa", ...(filterActive ? ['fa-angle-up'] : ['fa-angle-down'])]}></i>
                    </div>
                    <div className="materiable filter-button main list" onClick={this.filter}>
                        <i className="fa fa-filter"/> {tjs('filter_search')}
                    </div>
                    <div className="materiable filter-button small random bordered-right"
                         data-balloon={tjs('filter_random')}
                         data-balloon-pos="up-right" onClick={this.randomItem} ref={this.randomItemElement}>
                        <i className="far fa-random"/>
                    </div>
                </div>
            </div>
        );
    }


    public filter = async () => {
        if (this.element.classList.contains('blocked')) return;
        const filtersNew = {...this.filters};
        delete filtersNew.sort;
        delete filtersNew.sort_forward;
        if (Object.keys(filtersNew).length === 1) {
            if (filtersNew.genres?.length === 1) {
                window.location.href = "/catalog/category/" + genres.find(r => r.value == +filtersNew.genres![0])!.href + "?sort=popular";
                return;
            }
            if (filtersNew.status?.length === 1) {
                switch (+filtersNew.status[0]) {
                    case 1:
                        window.location.href = "/catalog/ongoing";
                        return;
                    case 2:
                        window.location.href = "/catalog/announcement";
                        return;
                }
            }
        }
        if (location.pathname.startsWith('/catalog/filter')) {
            try {
                this.element.classList.add('blocked');
                history.pushState(null, "", "/catalog/filter?" + this.buildParams());
                $('.content-page').html(
                    <div className="center">
                        <i className="loading fa large"/>
                    </div>
                );
                const animes = await this.getData(24, 0);
                $(".content-page").text('')[0]!.appendChild(
                    <FilterPage animes={animes} filters={{...this.filters, limit: 24, offset: 24}}/>
                )
            } catch (e) {
                handleFetchError(e);
            } finally {
                this.element.classList.remove('blocked');
            }
        } else {
            location.href = `/catalog/filter?${this.buildParams()}`;
        }
    }
    public randomItem = async () => {
        if (this.element.classList.contains('blocked')) return;
        this.element.classList.add('blocked');
        this.randomItemElement.value!.innerText = '';
        this.randomItemElement.value!.appendChild(<LoadingSpinner small={true}/> as Node);

        try {
            const randomItem = await this.getData(1, 0, 'random');
            if (!randomItem.length) {
                throw new YummyServerError(
                    "По таким фильтрам не найдено ни одного аниме!",
                    0,
                    'Аниме не найдено'
                );
            }
            window.location.href = `/catalog/item/${randomItem[0].anime_url}?${this.buildParams()}`;
        } catch (e) {
            handleFetchError(e);
        } finally {
            this.element.classList.remove('blocked');
            this.randomItemElement.value!.innerText = '';
            this.randomItemElement.value!.appendChild(<i className="far fa-random"/>)
        }
    }

    private async getData(limit: number, offset: number, sort?: Params['sort']) {
        const filters: FilterAnimeGetParams = {...this.filters, limit, offset};
        if (sort) filters.sort = sort;
        return ServerApi.anime.filter(filters)
    }
}


function filterSwitchToggle() {
    // $('.filter-switch .switch').toggleClass('active');

    $('.filter-block').addClass('ready').toggleClass('main').hasClass('main');
    const isActive = localStorage.filterSwitch === 'true';
    if (!isActive) {
        $('.icon-filter-expand').removeClass('fa-angle-down')
            .addClass('fa-angle-up');
        filterExpand()
    } else {
        $('.icon-filter-expand').removeClass('fa-angle-up')
            .addClass('fa-angle-down');
        $('.filter-block .collapse').each(function () {
            const that = $(this);
            that.css('max-height', that.children().outerHeight()!)
        }).attr('style', '');
    }
    localStorage.filterSwitch = (!isActive) + "";
}


// .on('click', '.filter-button', async function () {
//     const $this = $(this);
//     if (!$this.parent().hasClass('blocked')) {
//         $this.parent().addClass('blocked');
//         if ($this.hasClass('random')) {
//             const dataBuilder = new URLSearchParams();
//             // const anime = await ServerApi.anime.filter();
//             $this.parents('form.filter-block').serializeArray().forEach(function (e) {
//                 if (e.value) {
//                     dataBuilder.append(e.name, e.value);
//                 }
//             });
//             location.href = '/catalog/filter/?' + dataBuilder;
//         }
//         else if ($this.hasClass('clear')) {
//             const parent = $this.parents('form.filter-block');
//             parent.find('[name="date_range"]').data('dateRangePicker').clear();
//             parent.find('select').slimSet(0);
//             parent.find('input[type=checkbox]').prop('checked', false);
//             $this.parent().removeClass('blocked');
//         }
//         else {
//             $this.parents('form.filter-block').trigger('submit');
//         }
//     }
// })

